import React from 'react'
import { Box, Modal, Typography } from '@mui/material'
import { GeneralForm } from './ModalCollateral/GeneralForm';


const style = {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    color: 'black',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    height: '90vh',
    overflow: 'auto'         // Asegúrate de que el Box ocupa toda la altura disponible
};



export const ModalModule = ({ useFetchInit }) => {
    const { dataModal, toggle } = useFetchInit
    const { open, titleModal, componentModal, dataRequest } = dataModal
    const { message1, message2, message3 } = dataRequest || {}

    return (
        <>
            <Modal
                open={open}
                onClose={toggle}
                className='modal-body'
                disableEscapeKeyDown={true}
                size='xl'
            >
                <Box sx={style}>
                    <Typography variant="h6" component="h2">
                        {titleModal}
                        <p>{message1} {message2} {message3}</p>
                    </Typography>

                    {componentModal === 'collateral-section' && (
                        <GeneralForm useFetchInit={useFetchInit} dataModal={dataModal} />
                    )}
                </Box>
            </Modal>

        </>
    )
}